import { render, staticRenderFns } from "./createrefferalPartner.vue?vue&type=template&id=5905c11a&"
import script from "./createrefferalPartner.vue?vue&type=script&lang=js&"
export * from "./createrefferalPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports